import tokenUtils, { Environment } from './tokenUtils'
import {
  AuthProvider as BaseAuthProvider,
  AuthProviderProps,
} from './AuthContext'

export function configureAuth(env: Environment) {
  return {
    tokenUtils: tokenUtils(env),
    AuthProvider({ params, ...rest }: AuthProviderProps) {
      return <BaseAuthProvider {...rest} params={{ env, ...params }} />
    },
  }
}

export * from './AuthContext'
export { default as tokenUtils } from './tokenUtils'
export { getCookie, setCookie, deleteCookie } from './cookieUtils'
